import { useTranslation } from 'react-i18next';
import CountsGrid from '@/components/dashboard/CountsGrid';
import InFlightPanel from '@/components/dashboard/InFlightPanel';
import RecentFailuresPanel from '@/components/dashboard/RecentFailuresPanel';
import SystemBadges from '@/components/dashboard/SystemBadges';

export default function DashboardPage() {
  const { t } = useTranslation('dashboard');
  return (
    <div className="flex flex-col gap-6">
      <h2 className="text-2xl font-semibold">{t('title')}</h2>
      <SystemBadges />
      <CountsGrid />
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <InFlightPanel />
        <RecentFailuresPanel />
      </div>
    </div>
  );
}
